<template>
<div>
    <van-sticky :offset-top="50">
        <van-cell :title="'Depom: '+depom">
          <van-icon size="25" name="weapp-nav" />
        </van-cell>
      <van-field v-model="value1" left-icon="filter-o" right-icon="warning-o" placeholder="Stok ara" />
    </van-sticky>

           <van-pull-refresh v-model="isLoading" @refresh="onLoad">
            <div v-for="(item,index) in filteredList" :key="index" >
              <van-panel :title="item.sto_isim" :desc="item.marka+''+item.sto_kod" :status="item.adet+' Adet'">
                </van-panel>
              <!-- <van-swipe-cell>
                <van-cell :title="item.sto_isim" />
                  <template #right>
                  <van-button square type="primary" text="Adetler" @click="popshow = true;"/>
                  </template>
              </van-swipe-cell> -->
            </div>
           </van-pull-refresh>
<van-popup v-model="popshow" closeable close-icon-position="top-right-bottom" position="bottom" :style="{ heights: '30%' }">
                  <van-cell title="Merkez Depo" value="5"  />
                  <van-cell title="Yasir Depo" value="22"  />

</van-popup>
         <div style="height:70px"></div>
         <van-tabbar v-model="active">
          <van-tabbar-item name="Home" to="/" icon="wap-home-o">Home</van-tabbar-item>
          <van-tabbar-item name="Servis" to="/servis" icon="todo-list-o">Servis</van-tabbar-item>
          <van-tabbar-item name="Sepet" to="/sepet" icon="cluster-o">Ekibim</van-tabbar-item>
          <van-tabbar-item name="Depom" to="/depo" icon="apps-o">Depom</van-tabbar-item>
          <van-tabbar-item name="Cihaz" to="/gruplama" icon="fire-o">Cihaz</van-tabbar-item>
          <van-tabbar-item name="Hesabım" to="/hesap" icon="user-o">Hesap</van-tabbar-item>
         </van-tabbar>
<van-popup v-model="show"><van-loading type="spinner" color="#fff" /></van-popup>
</div>
</template>

<script>
import { Popup } from 'vant';
import { decode} from 'js-base64';

export default {
  data() {
    return {
      list: [],
      isLoading: false,
      active:'Depom',
      depolar: [],
      showPicker: false,
      ayar:this.$request.ayar(),
      value1:'',
      popshow:false,
      show:false,
      depom:decode(this.$request.ayar().genel.d),
      kisa:decode(this.$request.ayar().genel.s),
    };
  },
  computed:{
    filteredList() {
      return this.list.filter(post => {
        return post.sto_isim.toLowerCase().includes(this.value1.toLowerCase())
      })
    }    
  },  
  created(){
    this.show = true
    if (this.depom != '000000'){this.onLoad(this.depom)}
    else{
      alert("Depo Atanmamış")
      this.show = false
      }
    
  },
  methods: {

        onLoad(kod) {
          let depo = kod.split("#")
          this.$request.get("stoklar/"+depo[0]+"/"+this.kisa)
            .then(res => {this.list = res
            this.show= false
            this.isLoading = false;
            })
        },
          stokadet(id) { //diğer depolardaki adetler için yapıldı
            this.popshow = true;
             this.$request.get("stok/"+id)
            .then(res => {this.depolar = res.results
            })
        },
       
  }
};
</script>


// WEBPACK FOOTER //
// src/components/depo.vue